// extracted by mini-css-extract-plugin
export default {"next":"Next-page_next__us36Q"};